export class SnapshotRecipeDirectorySummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bytes",
            "baseName": "bytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotRecipeDirectorySummary.attributeTypeMap;
    }
    constructor() {
    }
}
